import React, { useState, useEffect } from 'react';

const API = 'https://api.pixventa.com';

const S = {
  topbar:     { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:         { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  seccion:    { marginBottom:24 },
  secHdr:     { display:'flex', alignItems:'center', gap:8, marginBottom:12 },
  secTitle:   { fontSize:14, fontWeight:700, color:'#0D1F1A' },
  secBadge:   { display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:600 },
  card:       { background:'white', borderRadius:12, border:'1px solid #E4EDE8', padding:'14px 16px', marginBottom:8, display:'flex', alignItems:'center', gap:16 },
  cardIcon:   { width:40, height:40, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0 },
  cardInfo:   { flex:1 },
  cardNombre: { fontSize:13, fontWeight:700, color:'#0D1F1A', marginBottom:2 },
  cardSub:    { fontSize:11, color:'#7A8F89' },
  cardBtns:   { display:'flex', gap:6, flexShrink:0 },
  btn:        { fontSize:11, padding:'6px 12px', borderRadius:8, border:'1px solid #E4EDE8', background:'none', color:'#7A8F89', cursor:'pointer', fontFamily:'inherit' },
  btnWA:      { background:'#25D366', color:'white', border:'none' },
  btnDesc:    { color:'#A32D2D', borderColor:'#F09595' },
  empty:      { background:'#F0F4F0', borderRadius:12, padding:'20px', textAlign:'center', fontSize:13, color:'#7A8F89' },
  cargando:   { textAlign:'center', padding:40, color:'#7A8F89', fontSize:13 },
  reloadBtn:  { padding:'6px 14px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#7A8F89', cursor:'pointer', fontFamily:'inherit' },
};

function diasEntre(fecha) {
  const hoy  = new Date(); hoy.setHours(0,0,0,0);
  const fin  = new Date(fecha); fin.setHours(0,0,0,0);
  return Math.round((fin - hoy) / (1000*60*60*24));
}

function formatFecha(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' });
}

export default function Alertas() {
  const [alertas,    setAlertas]    = useState([]);
  const [descartadas,setDescartadas] = useState([]);
  const [cargando,   setCargando]   = useState(true);

  useEffect(() => { cargarAlertas(); }, []);

  async function cargarAlertas() {
    try {
      setCargando(true);
      const [rTiendas, rSus] = await Promise.all([
        fetch(`${API}/admin/tiendas`).then(r => r.json()),
        fetch(`${API}/admin/suscripciones`).then(r => r.json()),
      ]);

      const hoy = new Date(); hoy.setHours(0,0,0,0);
      const lista = [];

      // Tiendas en prueba (sin suscripción activa)
      for (const t of rTiendas) {
        if (t.estado === 'prueba') {
          lista.push({
            id:       `prueba-${t.id}`,
            tienda_id: t.id,
            tipo:     'prueba',
            negocio:  t.nombre,
            subdominio: t.subdominio,
            plan:     t.plan_nombre || 'Sin plan',
            monto:    parseFloat(t.plan_precio || 0),
            tel:      t.tel || '',
            diasRestantes: null,
            fechaVencimiento: '—',
          });
        }
      }

      // Suscripciones activas — calcular vencimientos
      for (const s of rSus) {
        if (s.estado !== 'activo') continue;
        const dias = diasEntre(s.fecha_fin);
        const tienda = rTiendas.find(t => t.id === s.tienda_id);
        if (!tienda) continue;

        if (dias < 0) {
          // Vencida
          lista.push({
            id:          `vencido-${s.id}`,
            tienda_id:   tienda.id,
            tipo:        'vencido',
            negocio:     s.tienda_nombre || tienda.nombre,
            subdominio:  s.subdominio || tienda.subdominio,
            plan:        s.plan_nombre,
            monto:       parseFloat(s.monto),
            tel:         tienda.tel || '',
            diasVencido: Math.abs(dias),
            fechaVencimiento: formatFecha(s.fecha_fin),
          });
        } else if (dias <= 7) {
          // Próxima a vencer (7 días o menos)
          lista.push({
            id:          `proximo-${s.id}`,
            tienda_id:   tienda.id,
            tipo:        'proximo',
            negocio:     s.tienda_nombre || tienda.nombre,
            subdominio:  s.subdominio || tienda.subdominio,
            plan:        s.plan_nombre,
            monto:       parseFloat(s.monto),
            tel:         tienda.tel || '',
            diasRestantes: dias,
            fechaVencimiento: formatFecha(s.fecha_fin),
          });
        }
      }

      setAlertas(lista);
    } catch (err) {
      console.error('Error cargando alertas:', err);
    } finally {
      setCargando(false);
    }
  }

  function descartar(id) {
    if (!window.confirm('¿Descartar esta alerta?')) return;
    setDescartadas(prev => [...prev, id]);
  }

  function solicitarPago(a) {
    const num = (a.tel || '').replace(/\D/g,'');
    const msg = a.tipo === 'vencido'
      ? `Hola 👋\n\nTe recordamos que tu suscripción de *WhatMarket* (${a.plan}) ha vencido hace ${a.diasVencido} días.\n\nPara continuar usando tu tienda *${a.subdominio}.pixventa.com* realiza tu pago de $${Number(a.monto).toLocaleString('es-MX',{minimumFractionDigits:2})} MXN.\n\n¿Tienes alguna duda? Con gusto te ayudamos. 🙏`
      : a.tipo === 'proximo'
      ? `Hola 👋\n\nTe recordamos que tu suscripción de *WhatMarket* (${a.plan}) vence en ${a.diasRestantes} días (${a.fechaVencimiento}).\n\nRenueva a tiempo para no perder acceso a tu tienda *${a.subdominio}.pixventa.com*. 🙏`
      : `Hola 👋\n\nEsperamos que estés disfrutando tu periodo de prueba en *WhatMarket*.\n\n¿Te gustaría activar tu suscripción y seguir vendiendo? Con gusto te ayudamos a elegir el mejor plan. 😊`;
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
  }

  const visibles = alertas.filter(a => !descartadas.includes(a.id));
  const vencidas = visibles.filter(a => a.tipo === 'vencido');
  const proximas = visibles.filter(a => a.tipo === 'proximo');
  const prueba   = visibles.filter(a => a.tipo === 'prueba');

  if (cargando) return <div style={S.cargando}>Cargando alertas...</div>;

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Alertas ({visibles.length})</h1>
        <button style={S.reloadBtn} onClick={cargarAlertas}>↻ Actualizar</button>
      </div>

      {/* Vencidas */}
      <div style={S.seccion}>
        <div style={S.secHdr}>
          <span style={{ fontSize:18 }}>🔴</span>
          <div style={S.secTitle}>Pagos vencidos</div>
          <span style={{ ...S.secBadge, background:'#FCEBEB', color:'#501313' }}>{vencidas.length}</span>
        </div>
        {vencidas.length === 0 && <div style={S.empty}>✅ Sin pagos vencidos</div>}
        {vencidas.map(a => (
          <div key={a.id} style={{ ...S.card, borderLeft:'3px solid #c62828' }}>
            <div style={{ ...S.cardIcon, background:'#FCEBEB' }}>⚠️</div>
            <div style={S.cardInfo}>
              <div style={S.cardNombre}>{a.negocio}</div>
              <div style={S.cardSub}>{a.subdominio}.pixventa.com · Plan {a.plan}</div>
              <div style={{ fontSize:12, color:'#A32D2D', fontWeight:600, marginTop:4 }}>
                Vencido hace {a.diasVencido} día{a.diasVencido!==1?'s':''} — {a.fechaVencimiento}
                {a.monto > 0 && ` · $${Number(a.monto).toLocaleString('es-MX',{minimumFractionDigits:2})} MXN`}
              </div>
            </div>
            <div style={S.cardBtns}>
              <button style={{ ...S.btn, ...S.btnWA }} onClick={() => solicitarPago(a)}>📲 Cobrar</button>
              <button style={{ ...S.btn, ...S.btnDesc }} onClick={() => descartar(a.id)}>✕ Descartar</button>
            </div>
          </div>
        ))}
      </div>

      {/* Próximas a vencer */}
      <div style={S.seccion}>
        <div style={S.secHdr}>
          <span style={{ fontSize:18 }}>🟡</span>
          <div style={S.secTitle}>Próximas a vencer (7 días)</div>
          <span style={{ ...S.secBadge, background:'#FFF3E0', color:'#E65100' }}>{proximas.length}</span>
        </div>
        {proximas.length === 0 && <div style={S.empty}>✅ Sin vencimientos próximos</div>}
        {proximas.map(a => (
          <div key={a.id} style={{ ...S.card, borderLeft:'3px solid #f57f17' }}>
            <div style={{ ...S.cardIcon, background:'#FFF3E0' }}>⏰</div>
            <div style={S.cardInfo}>
              <div style={S.cardNombre}>{a.negocio}</div>
              <div style={S.cardSub}>{a.subdominio}.pixventa.com · Plan {a.plan}</div>
              <div style={{ fontSize:12, color:'#e65100', fontWeight:600, marginTop:4 }}>
                Vence en {a.diasRestantes} día{a.diasRestantes!==1?'s':''} — {a.fechaVencimiento}
                {a.monto > 0 && ` · $${Number(a.monto).toLocaleString('es-MX',{minimumFractionDigits:2})} MXN`}
              </div>
            </div>
            <div style={S.cardBtns}>
              <button style={{ ...S.btn, ...S.btnWA }} onClick={() => solicitarPago(a)}>📲 Recordar</button>
              <button style={{ ...S.btn, ...S.btnDesc }} onClick={() => descartar(a.id)}>✕ Descartar</button>
            </div>
          </div>
        ))}
      </div>

      {/* En periodo de prueba */}
      <div style={S.seccion}>
        <div style={S.secHdr}>
          <span style={{ fontSize:18 }}>🔵</span>
          <div style={S.secTitle}>En periodo de prueba</div>
          <span style={{ ...S.secBadge, background:'#E6F1FB', color:'#042C53' }}>{prueba.length}</span>
        </div>
        {prueba.length === 0 && <div style={S.empty}>Sin negocios en periodo de prueba</div>}
        {prueba.map(a => (
          <div key={a.id} style={{ ...S.card, borderLeft:'3px solid #1565c0' }}>
            <div style={{ ...S.cardIcon, background:'#E6F1FB' }}>🆓</div>
            <div style={S.cardInfo}>
              <div style={S.cardNombre}>{a.negocio}</div>
              <div style={S.cardSub}>{a.subdominio}.pixventa.com · Plan {a.plan}</div>
              <div style={{ fontSize:12, color:'#1565c0', fontWeight:600, marginTop:4 }}>
                Periodo de prueba activo
              </div>
            </div>
            <div style={S.cardBtns}>
              <button style={{ ...S.btn, ...S.btnWA }} onClick={() => solicitarPago(a)}>📲 Invitar a pagar</button>
              <button style={{ ...S.btn, ...S.btnDesc }} onClick={() => descartar(a.id)}>✕ Descartar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}